import React, { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';

const NotificationsPage = () => {
  const [notificationMethods, setNotificationMethods] = useState({
    email: { enabled: false, emailAddress: '' },
    http: { enabled: false, url: '', ssl: false },
    syslogd: { enabled: false, address: '' },
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { API_BASE_URL} = useAuth();

  useEffect(() => {
    // Fetch current notification settings from the backend
    const token = localStorage.getItem('token');
    fetch(API_BASE_URL+'notifications', {
      headers: { Authorization: token },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to fetch notifications');
        }
        return res.json();
      })
      .then((data) => {
        setNotificationMethods((prev) => ({
          ...prev,
          ...data,
        }));
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching notifications:', err);
        setError('Failed to load notification settings. Default values are displayed.');
        setLoading(false);
      });
  }, []);

  const handleToggle = (method) => {
    setNotificationMethods((prev) => ({
      ...prev,
      [method]: { ...prev[method], enabled: !prev[method].enabled },
    }));
  };

  const handleInputChange = (method, field, value) => {
    setNotificationMethods((prev) => ({
      ...prev,
      [method]: { ...prev[method], [field]: value },
    }));
  };

  const handleSave = (method) => {
    const token = localStorage.getItem('token');
    fetch(`/api/notifications/${method}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(notificationMethods[method]),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to update ${method} notification settings`);
        }
        return res.json();
      })
      .then(() => alert(`${method} notification settings updated successfully`))
      .catch((err) => console.error(err));
  };

  if (loading) {
    return <p>Loading notification settings...</p>;
  }

  return (
    <div>
      <h2>Notifications</h2>
      {error && <div className="alert alert-warning">{error}</div>}

      <div className="mb-3">
        <h4>Email Notifications</h4>
        <div className="form-check form-switch mb-2">
          <input
            type="checkbox"
            className="form-check-input"
            checked={notificationMethods.email.enabled}
            onChange={() => handleToggle('email')}
          />
          <label className="form-check-label">Enable Email Notifications</label>
        </div>
        {notificationMethods.email.enabled && (
          <div className="mb-3">
            <label className="form-label">Email Address</label>
            <input
              type="email"
              className="form-control"
              value={notificationMethods.email.emailAddress}
              onChange={(e) => handleInputChange('email', 'emailAddress', e.target.value)}
            />
            <button
              className="btn btn-primary mt-2"
              onClick={() => handleSave('email')}
            >
              Save
            </button>
          </div>
        )}
      </div>

      <div className="mb-3">
        <h4>HTTP REST Notifications</h4>
        <div className="form-check form-switch mb-2">
          <input
            type="checkbox"
            className="form-check-input"
            checked={notificationMethods.http.enabled}
            onChange={() => handleToggle('http')}
          />
          <label className="form-check-label">Enable HTTP Notifications</label>
        </div>
        {notificationMethods.http.enabled && (
          <div className="mb-3">
            <label className="form-label">URL</label>
            <input
              type="text"
              className="form-control"
              value={notificationMethods.http.url}
              onChange={(e) => handleInputChange('http', 'url', e.target.value)}
            />
            <div className="form-check mt-2">
              <input
                type="checkbox"
                className="form-check-input"
                checked={notificationMethods.http.ssl}
                onChange={(e) => handleInputChange('http', 'ssl', e.target.checked)}
              />
              <label className="form-check-label">Use SSL</label>
            </div>
            <button
              className="btn btn-primary mt-2"
              onClick={() => handleSave('http')}
            >
              Save
            </button>
          </div>
        )}
      </div>

      <div className="mb-3">
        <h4>Syslogd Notifications</h4>
        <div className="form-check form-switch mb-2">
          <input
            type="checkbox"
            className="form-check-input"
            checked={notificationMethods.syslogd.enabled}
            onChange={() => handleToggle('syslogd')}
          />
          <label className="form-check-label">Enable Syslogd Notifications</label>
        </div>
        {notificationMethods.syslogd.enabled && (
          <div className="mb-3">
            <label className="form-label">Syslogd Address</label>
            <input
              type="text"
              className="form-control"
              value={notificationMethods.syslogd.address}
              onChange={(e) => handleInputChange('syslogd', 'address', e.target.value)}
            />
            <button
              className="btn btn-primary mt-2"
              onClick={() => handleSave('syslogd')}
            >
              Save
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationsPage;
